<template>
  <span class="bubble">
    {{ num }}
  </span>
</template>

<script>
export default {
  name: 'bubble',
  props: {
    num: {
      type: Number
    }
  }
}
</script>

<style lang="stylus" scoped>
  .bubble
    display: inline-block
    padding: 0 0.25rem
    height: 0.8rem
    line-height: 0.8rem
    text-align: center
    border-radius: 0.8rem
    font-family: Helvetica
    font-weight: 700
    font-size: 0.5rem
    color: #fff
    background: linear-gradient(to right, #fc9153, #f01414)
</style>
